import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.splide')) {
    new Splide('.splide', {
      rewind: 'true',
      rewindSpeed: 1000,
      pagination: false,
      drag: false,
    }).mount()
  }
})
